import React from "react";
import { connect } from "react-redux";
import { Grid, Form } from "semantic-ui-react";
import TypesFilterDropdown from "@components/Compliance/filters/TypesFilterDropdown";
import PeriodFilters from "@components/Compliance/filters/PeriodFilters";
import useComplianceView from "@hooks/useComplianceView";
import useComplianceSummaryFilters from "@hooks/useComplianceSummaryFilters";
import SearchInput from "@shared/SearchInput";
import DateFiltersDropdown from "@shared/DateFiltersDropdown";
import ComplianceSummaryButtons from "@components/Compliance/summary/ComplianceSummaryButtons";
import EventDetailsButtons from "@components/Compliance/details/EventDetailsButtons";
import OrgTreeButton from "../../buttons/OrgTreeButton";
import { fetchComplianceFilters } from "@actions";

const MainFilters = (props) => {
  const { activeIndex, allNames, isLoading, hasSelection } =
    useComplianceView();
  const { periods, onAllNamesChange, processedQuarters, onPeriodChange } =
    useComplianceSummaryFilters();
  const { showOrgTree } = props.filters;
  const disabled = isLoading || !hasSelection;

  return (
    <>
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Form className="mb-0">
              <Form.Group className="mb-0">
                <PeriodFilters />
                <TypesFilterDropdown />
                {activeIndex === 0 && (
                  <SearchInput
                    name="allNames"
                    value={allNames}
                    disabled={disabled}
                    onChange={onAllNamesChange}
                  />
                )}
              </Form.Group>
            </Form>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column
            className="flex-row-center"
            width={8}
            verticalAlign="middle"
          >
            <OrgTreeButton
              active={showOrgTree}
              onClick={() =>
                props.fetchComplianceFilters({
                  showOrgTree: !showOrgTree,
                })
              }
            />
            <Form className="mb-0_5 ml-0_5">
              <DateFiltersDropdown
                text="Periods"
                disabled={disabled}
                items={periods}
                onChange={onPeriodChange}
              />
              <DateFiltersDropdown
                className="ml-1"
                disabled={disabled}
                text="Processed Quarters"
                items={processedQuarters}
                onChange={onPeriodChange}
              />
            </Form>
          </Grid.Column>
          <Grid.Column width={8} textAlign="right">
            {activeIndex !== 0 ? (
              <ComplianceSummaryButtons />
            ) : (
              <EventDetailsButtons />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    filters: state.complianceFilters,
  };
};

export default connect(mapStateToProps, {
  fetchComplianceFilters,
})(MainFilters);
